import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-localstorage-backend';
import RESOURCES from './translation';

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: RESOURCES,
    lng: 'es',
    fallbackLng: 'es',
    //debug: true,
    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    }
  });

export default i18n;
